<script setup lang="ts">
import CheckIcon from '@/assets/icons/shared/check.svg';
</script>

<template>
  <div class="document-active">
    <CheckIcon class="icon" />
  </div>
</template>

<style scoped lang="scss">
.document-active {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border-radius: 50%;
  background-color: var(--color-green-800);
}

.icon {
  fill: var(--color-white);
}
</style>
